/* evx-pdp.js - gegenereerd door Everley HQ. Niet handmatig bewerken. */
(function () {
  "use strict";
  var ROOT = document.querySelector("[data-evx-buy]");
  if (!ROOT) return;
  var CARDS = ROOT.querySelectorAll("[data-evx-card]");
  var ROWS = ROOT.querySelector("[data-evx-rows]");
  var ATC = ROOT.querySelector("[data-evx-atc]");
  var NOTE = ROOT.querySelector("[data-evx-note]");
  var TOPNOW = ROOT.querySelector("[data-evx-top-now]");
  var TOPWAS = ROOT.querySelector("[data-evx-top-was]");
  var TOPSAVE = ROOT.querySelector("[data-evx-top-save]");
  var STICK = document.querySelector("[data-evx-sticky]");
  var STICKBTN = document.querySelector("[data-evx-sticky-atc]");
  var STICKNAME = document.querySelector("[data-evx-sticky-name]");
  var STICKPRICE = document.querySelector("[data-evx-sticky-price]");

  function readJson(sel, dflt) {
    var n = ROOT.querySelector(sel);
    if (!n) return dflt;
    try { return JSON.parse(n.textContent || "null") || dflt; } catch (e) { return dflt; }
  }

  var VS = readJson("[data-evx-variants]", []);
  var OPTS = readJson("[data-evx-options]", []);
  var QTY = 1;
  var PICK = [];

  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function idxOf(re) {
    for (var i = 0; i < OPTS.length; i++) { if (re.test(String(OPTS[i] || ""))) return i; }
    return -1;
  }
  var CI = idxOf(/colou?r/i);
  var SI = idxOf(/size|maat/i);

  function uniq(idx) {
    var out = [], seen = {};
    if (idx < 0) return out;
    for (var i = 0; i < VS.length; i++) {
      var val = VS[i].o && VS[i].o[idx];
      if (!val || seen[val]) continue;
      seen[val] = 1; out.push(val);
    }
    return out;
  }
  var COLORS = uniq(CI);
  var SIZES = uniq(SI);

  function swatch(color) {
    for (var i = 0; i < VS.length; i++) { if (VS[i].o && VS[i].o[CI] === color && VS[i].img) return VS[i].img; }
    return null;
  }
  function findVariant(color, size) {
    for (var i = 0; i < VS.length; i++) {
      var v = VS[i];
      if (CI >= 0 && color && v.o[CI] !== color) continue;
      if (SI >= 0 && size && v.o[SI] !== size) continue;
      if (CI >= 0 && !color) continue;
      if (SI >= 0 && !size) continue;
      return v;
    }
    return VS.length === 1 ? VS[0] : null;
  }
  function inStock(color, size) { var v = findVariant(color, size); return !!(v && v.a); }
  function colorHasStock(color) {
    if (!SIZES.length) return inStock(color, null);
    for (var i = 0; i < SIZES.length; i++) { if (inStock(color, SIZES[i])) return true; }
    return false;
  }
  function firstStockColor() {
    for (var i = 0; i < COLORS.length; i++) { if (colorHasStock(COLORS[i])) return COLORS[i]; }
    return COLORS[0] || null;
  }
  function done(i) {
    var p = PICK[i] || {};
    return (!COLORS.length || !!p.color) && (!SIZES.length || !!p.size) && !!findVariant(p.color, p.size);
  }
  function doneCount() { var n = 0; for (var i = 0; i < QTY; i++) { if (done(i)) n++; } return n; }

  function rowHtml(i) {
    var p = PICK[i] || {};
    var h = '<div class="evx-row" data-evx-row="' + i + '">';
    h += '<p class="evx-rowh">Item ' + (i + 1) + ' of ' + QTY + '</p>';
    if (COLORS.length) {
      h += '<p class="evx-lab">Colour</p><div class="evx-sw">';
      for (var c = 0; c < COLORS.length; c++) {
        var col = COLORS[c];
        var img = swatch(col);
        var ok = colorHasStock(col);
        h += '<button type="button" class="evx-swb' + (p.color === col ? " is-on" : "") + '"' +
          (ok ? "" : " disabled") + ' data-evx-color="' + esc(col) + '" title="' + esc(col) + '"' +
          ' aria-label="' + esc(col) + '"' + (img ? ' style="background-image:url(' + esc(img) + ')"' : "") + "></button>";
      }
      h += "</div>";
    }
    if (SIZES.length) {
      h += '<p class="evx-lab">Size</p><div class="evx-sizes">';
      for (var s = 0; s < SIZES.length; s++) {
        var sz = SIZES[s];
        var avail = inStock(p.color, sz);
        h += '<button type="button" class="evx-szb' + (p.size === sz ? " is-on" : "") + '"' +
          (avail ? "" : " disabled") + ' data-evx-size="' + esc(sz) + '">' + esc(sz) + "</button>";
      }
      h += "</div>";
    }
    return h + "</div>";
  }

  function paint() {
    var h = "";
    for (var i = 0; i < QTY; i++) { h += rowHtml(i); }
    ROWS.innerHTML = h;
    var left = QTY - doneCount();
    NOTE.textContent = left > 0 ? "Choose " + left + " more item" + (left === 1 ? "" : "s") : "";
  }

  function setQty(q) {
    QTY = q;
    var last = null;
    for (var i = 0; i < PICK.length; i++) { if (PICK[i]) last = PICK[i]; }
    while (PICK.length < QTY) {
      PICK.push({
        color: (last && last.color) || firstStockColor(),
        size: last && last.size ? last.size : null
      });
    }
    PICK.length = QTY;
    paint();
  }

  function tierName(card) {
    var m = card.querySelector(".evx-cname");
    return m ? m.textContent : "";
  }
  function selectTier(q) {
    for (var i = 0; i < CARDS.length; i++) {
      var on = Number(CARDS[i].getAttribute("data-evx-qty")) === q;
      CARDS[i].className = CARDS[i].className.replace(/\s*is-on/g, "") + (on ? " is-on" : "");
      CARDS[i].setAttribute("aria-checked", on ? "true" : "false");
      if (!on) continue;
      var card = CARDS[i];
      TOPNOW.textContent = card.getAttribute("data-evx-total");
      var hasSave = card.getAttribute("data-evx-hassave") === "1";
      TOPWAS.textContent = card.getAttribute("data-evx-list");
      TOPWAS.hidden = !hasSave;
      TOPSAVE.textContent = hasSave ? "You save " + card.getAttribute("data-evx-saved") : "";
      TOPSAVE.hidden = !hasSave;
      if (STICKNAME) STICKNAME.textContent = tierName(card);
      if (STICKPRICE) STICKPRICE.textContent = card.getAttribute("data-evx-total");
    }
    setQty(q);
  }

  function proof(route) {
    try {
      window.__EVX_CART_PROOF = {
        mode: ROOT.getAttribute("data-evx-cart-mode"),
        route: route,
        at: (new Date()).getTime()
      };
    } catch (e) {}
  }
  function drawerNode() {
    return document.querySelector("cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, [data-cart-drawer]");
  }
  function drawerLooksOpen() {
    var hit = document.querySelector("cart-drawer.active, cart-drawer.is-open, .cart-drawer.active, .cart-drawer.is-open, .drawer--cart.is-open, .drawer--cart.active, [data-cart-drawer].is-open");
    if (hit) return true;
    var d = drawerNode();
    if (!d) return false;
    var r = d.getBoundingClientRect();
    if (r.width < 40 || r.height < 40) return false;
    var st = window.getComputedStyle(d);
    return st.visibility !== "hidden" && st.display !== "none" && Number(st.opacity) > 0.1;
  }
  function fire(name) {
    try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: "evx" } })); } catch (e) {}
  }
  function openCartDrawer(cb) {
    fire("cart:refresh"); fire("cart:build"); fire("cart:open"); fire("cart-drawer:open"); fire("cart:updated"); fire("ajaxProduct:added");
    try { if (window.jQuery) window.jQuery(document).trigger("cart:refresh"); } catch (e) {}
    var d = drawerNode();
    try { if (d && typeof d.open === "function") d.open(); } catch (e) {}
    if (!drawerLooksOpen()) {
      try {
        var t = document.querySelector("[data-cart-drawer-toggle], .header__icon--cart, a[href='/cart']");
        if (t) t.click();
      } catch (e) {}
    }
    window.setTimeout(function () { cb(drawerLooksOpen()); }, 700);
  }

  function unlock() { ATC.disabled = false; if (STICKBTN) STICKBTN.disabled = false; }

  function afterAdd() {
    var mode = ROOT.getAttribute("data-evx-cart-mode") || "drawer";
    if (mode !== "drawer") { proof("page"); window.location.href = "/cart"; return; }
    openCartDrawer(function (ok) {
      if (ok) { proof("drawer"); NOTE.textContent = "Added to your cart."; unlock(); return; }
      proof("fallback-page");
      window.location.href = "/cart";
    });
  }

  function addToCart() {
    var merged = {}, order = [];
    for (var i = 0; i < QTY; i++) {
      var p = PICK[i];
      var v = findVariant(p.color, p.size);
      if (!v) { paint(); return; }
      if (!merged[v.id]) { merged[v.id] = 0; order.push(v.id); }
      merged[v.id]++;
    }
    var items = [];
    for (var n = 0; n < order.length; n++) { items.push({ id: order[n], quantity: merged[order[n]] }); }
    ATC.disabled = true;
    if (STICKBTN) STICKBTN.disabled = true;
    NOTE.textContent = "Adding to cart...";
    window.fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart " + r.status);
      return r.json();
    }).then(function () {
      afterAdd();
    })["catch"](function () {
      unlock();
      NOTE.textContent = "Could not add to cart - please try again.";
    });
  }

  function watchSticky() {
    if (!STICK) return;
    var ticking = false;
    function calc() {
      ticking = false;
      var r = ATC.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      STICK.hidden = !(r.bottom < 0 || r.top > h);
    }
    function onScroll() { if (ticking) return; ticking = true; window.setTimeout(calc, 60); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    calc();
  }

  ROOT.addEventListener("click", function (e) {
    var card = e.target.closest ? e.target.closest("[data-evx-card]") : null;
    if (card) { selectTier(Number(card.getAttribute("data-evx-qty")) || 1); return; }
    var sw = e.target.closest ? e.target.closest("[data-evx-color]") : null;
    var sz = e.target.closest ? e.target.closest("[data-evx-size]") : null;
    var row = e.target.closest ? e.target.closest("[data-evx-row]") : null;
    if (!row) return;
    var i = Number(row.getAttribute("data-evx-row"));
    if (!PICK[i]) PICK[i] = { color: null, size: null };
    if (sw) {
      PICK[i].color = sw.getAttribute("data-evx-color");
      if (PICK[i].size && !inStock(PICK[i].color, PICK[i].size)) PICK[i].size = null;
    } else if (sz) {
      PICK[i].size = sz.getAttribute("data-evx-size");
      for (var m = i + 1; m < QTY; m++) {
        if (!done(m) && inStock(PICK[m].color, PICK[i].size)) PICK[m].size = PICK[i].size;
      }
    } else { return; }
    paint();
  });

  ATC.addEventListener("click", function (e) { e.preventDefault(); addToCart(); });
  if (STICKBTN) {
    STICKBTN.addEventListener("click", function (e) {
      e.preventDefault();
      if (doneCount() < QTY) { ROOT.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
      addToCart();
    });
  }

  function init() {
    if (!VS.length || !CARDS.length) {
      if (window.console && console.warn) console.warn("[evx] geen varianten of tiers - het gewone formulier blijft staan");
      return;
    }
    selectTier(Number(ROOT.getAttribute("data-evx-hero")) || Number(CARDS[CARDS.length - 1].getAttribute("data-evx-qty")) || 1);
    watchSticky();
    document.documentElement.className += " evx-ready";
  }
  try {
    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
  } catch (e) {
    if (window.console && console.warn) console.warn("[evx] init faalde", e);
  }
})();
